import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './PolicyPage.css';

export default function TermsOfService() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="policy-page">
      <div className="policy-hero">
        <div className="container">
          <Link to="/" className="policy-back-link">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="15 18 9 12 15 6"/></svg>
            Back to Home
          </Link>
          <h1 className="policy-page-title">Terms of Service</h1>
          <p className="policy-meta">Last updated: May 2025 · iLOVEthisGAME Canada</p>
        </div>
      </div>

      <div className="container">
        <div className="policy-body">
          <div className="policy-callout glass-panel">
            <p>
              <strong>OVERVIEW:</strong> This website is operated by <strong>iLOVEthisGAME</strong>. Throughout the site, the terms “we”, “us” and “our” refer to iLOVEthisGAME. iLOVEthisGAME offers this website, including all information, tools and services available from this site to you, the user, conditioned upon your acceptance of all terms, conditions, policies and notices stated here.
            </p>
          </div>

          <h2>SECTION 1 — ONLINE STORE TERMS</h2>
          <p>
            By agreeing to these Terms of Service, you represent that you are at least the age of majority in your state or province of residence, or that you are the age of majority in your state or province of residence and you have given us your consent to allow any of your minor dependents to use this site.
          </p>
          <p>
            You may not use our products for any illegal or unauthorized purpose nor may you, in the use of the Service, violate any laws in your jurisdiction (including but not limited to copyright laws).
          </p>
          <p>A breach or violation of any of the Terms will result in an immediate termination of your Services.</p>

          <h2>SECTION 2 — GENERAL CONDITIONS</h2>
          <p>We reserve the right to refuse service to anyone for any reason at any time.</p>
          <p>
            You understand that your content (not including credit card information), may be transferred unencrypted and involve (a) transmissions over various networks; and (b) changes to conform and adapt to technical requirements of connecting networks or devices. Credit card information is always encrypted during transfer over networks.
          </p>
          <p>
            You agree not to reproduce, duplicate, copy, sell, resell or exploit any portion of the Service, use of the Service, or access to the Service or any contact on the website through which the service is provided, without express written permission by us.
          </p>

          <h2>SECTION 3 — ACCURACY, COMPLETENESS AND TIMELINESS OF INFORMATION</h2>
          <p>
            We are not responsible if information made available on this site is not accurate, complete or current. The material on this site is provided for general information only and should not be relied upon or used as the sole basis for making decisions without consulting primary, more accurate, more complete or more timely sources of information. Any reliance on the material on this site is at your own risk.
          </p>

          <h2>SECTION 4 — MODIFICATIONS TO THE SERVICE AND PRICES</h2>
          <p>Prices for our products (such as Playermaker 2.0 Kits and Replacement Straps) are subject to change without notice.</p>
          <p>
            We reserve the right at any time to modify or discontinue the Service (or any part or content thereof) without notice at any time. We shall not be liable to you or to any third-party for any modification, price change, suspension or discontinuance of the Service.
          </p>

          <h2>SECTION 5 — PRODUCTS OR SERVICES</h2>
          <p>
            Certain products or services may be available exclusively online through the website. These products or services may have limited quantities and are subject to return or exchange according to our warranty and return policy.
          </p>
          <p>
            We have made every effort to display as accurately as possible the colors and images of our products that appear at the store. We cannot guarantee that your computer monitor's display of any color will be accurate.
          </p>
          <p>
            We reserve the right, but are not obligated, to limit the sales of our products or Services to any person, geographic region or jurisdiction. We may exercise this right on a case-by-case basis.
          </p>

          <h2>SECTION 6 — ACCURACY OF BILLING AND ACCOUNT INFORMATION</h2>
          <p>
            We reserve the right to refuse any order you place with us. We may, in our sole discretion, limit or cancel quantities purchased per person, per household or per order. In the event that we make a change to or cancel an order, we may attempt to notify you by contacting the email and/or billing address/phone number provided at the time the order was made.
          </p>

          <h2>SECTION 7 — THIRD-PARTY LINKS &amp; TOOLS</h2>
          <p>
            Certain content, products and services available via our Service may include materials from third-parties (such as Playermaker official support or analytics tools). Third-party links on this site may direct you to third-party websites that are not affiliated with us. We are not responsible for examining or evaluating the content or accuracy and we do not warrant and will not have any liability or responsibility for any third-party materials or websites.
          </p>

          <h2>SECTION 8 — PERSONAL INFORMATION</h2>
          <p>
            Your submission of personal information through the store is governed by our <Link to="/privacy-policy">Privacy Policy</Link>.
          </p>

          <h2>SECTION 9 — GOVERNING LAW</h2>
          <p>
            These Terms of Service and any separate agreements whereby we provide you Services shall be governed by and construed in accordance with the laws of British Columbia and Canada.
          </p>

          <h2>SECTION 10 — CONTACT INFORMATION</h2>
          <p>
            Questions about the Terms of Service should be sent to us via our <Link to="/contact">Contact Page</Link>.
          </p>

          <div className="policy-divider" />
          <p style={{ fontSize: '1.1rem', color: 'var(--text-muted)' }}>iLOVEthisGAME · Official Canadian Partner of Playermaker · British Columbia, Canada</p>
        </div>
      </div>
    </div>
  );
}
